const pricingTypes = {
    ton: 'By Ton',
    flat: 'Flat Rate',
    yard: 'By Yard',
};
export default pricingTypes;
export const pricingTypesEnums = {
    ton: 'ton',
    flat: 'flat',
    yard: 'yard',
};
//# sourceMappingURL=pricing-types.js.map